module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAA9CAYAAADvaTpkAAAABGdBTUEAALGPC/xhBQAAARJJREFUaAXtmjEOgkAQRXeNobb1CvZcgc4reA07a70Gd9EjeARobbXB/yPSCJTAmjfJBFjY7P9vlmayoWmaTHlWVsrUwpqtPYu+CSEclSnHxUYqOdim7ELa61XiBjr5NlJ2T+nelGtpP7X6D7qmtsVqaXYhvh5aK1wgAAEIQAACEIAABCAAAQhAAAIQgMCUBNS8y5VX5VM5V3hta8jHvMehl5ro1tBduRn6ZuLxh9bbxRjdAvqJsU7jXl8vxYSFW4s19caYkd4JSx38/63V7sVCFbgpXzNWwmtbQzH0f8yojaUhAAEIQAACEIAABCAAAQhAAAIQgEBqBNQa5bjsgorGcdkFFeMjxU1sn9JMPf7nuOwbaHdDzfI5M2AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/WebLogo.png
// module id = 27
// module chunks = 0